<template>
  <application-item
    :application=application
    :application-key="applicationKey"
    :pagination="pagination"
    :user="user"
    :statuses="statuses"
    :needImage="false"
    @update-statuses="updateStatuses"
    @splice-application="spliceApplication"
  >
    <template v-slot:menu="slotProps">
      <visitor-action-list-menu
        :visitor="applicationVisitor"
        :visitor-key="visitorKey"
        :application="application"
        :application-key="applicationKey"
        :transports="applicationVisitor.transports"
        :approval-command="slotProps.approvalCommand"
        :get-signer="slotProps.getSigner"
        :base-url="baseUrl"
        ref="listmenu"
      >
        <template v-slot:prevItems>
          <b-dropdown-item v-if="canView(application)" :href="url('view')" class="watch-button">
            <dropdown-image :other-icon-path="iconsPath" icon-name="show.svg" />
            Посмотреть
          </b-dropdown-item>

          <b-dropdown-item v-if="canPrint(application)" v-html="applicationPdf" />

          <b-dropdown-item v-if="canContinueEdit(application)" :href="url('draft')">
            <dropdown-image :other-icon-path="iconsPath" icon-name="edit.svg" />
            Продолжить редактирование
          </b-dropdown-item>

          <b-dropdown-item v-if="canAttachScanCopy(application)" :href="url('view', '#scan-copy-block')">
            <dropdown-image :other-icon-path="iconsPath" icon-name="scan.svg" />
            Приложить скан-копию
          </b-dropdown-item>
        </template>

        <template v-slot:lastItems>
          <b-dropdown-item v-if="canDuplicate(application)" :href="url('duplicate_id', '#new')">
            <dropdown-image :other-icon-path="iconsPath" icon-name="copy.svg" />
            Дублировать
          </b-dropdown-item>

          <b-dropdown-item v-if="canEdit" :href="url('edit')">
            <dropdown-image :other-icon-path="iconsPath" icon-name="edit.svg" />
            Редактировать
          </b-dropdown-item>

          <b-dropdown-item v-if="canDelete(application)" @click="deleteApplication(application)">
            <dropdown-image :other-icon-path="iconsPath" icon-name="delete.svg" />
            Удалить
          </b-dropdown-item>
        </template>
      </visitor-action-list-menu>
    </template>
    <template v-slot:afterData>
      <div class="visitor-application-transport" v-if="applicationVisitor.transports && applicationVisitor.transports.length > 0">
        <div class="row visitor-application-transport-info">
          <div class="col-md-1 col-xs-1">
            <span class="name-label">Тип</span>
          </div>
          <div class="col-md-2 col-xs-3">
            <span class="name-label">Номер / Прицеп</span>
          </div>
          <div class="col-md-2 col-xs-3">
            <span class="name-label">Марка / Модель</span>
          </div>
          <div class="col-md-2 col-xs-2">
            <span class="name-label">Цвет</span>
          </div>
          <div class="col-md-3 col-xs-3">
            <span class="name-label">Собственник</span>
          </div>
        </div>
        <div
          v-for="(transport, key) in applicationVisitor.transports"
          :key="key"
          class="row visitor-application-transport-info"
          style="{ display: flex; align-items: center }"
        >
          <div class="col-md-1 col-xs-1">
            <img
              v-if="transport.type"
              :src="baseUrl + '/img/icons/' + transport.type + '.png'"
              data-toggle='tooltip'
              class="lock-icon"
              alt=""
            >
          </div>
          <div class="col-md-2 col-xs-3">
            <p v-if="transport.number">
              {{ transport.number ? transport.number : '' }}
              <br v-if="transport.trailer">
              {{ transport.trailer ? transport.trailer : '' }}
            </p>
            <p v-else>-</p>
          </div>
          <div class="col-md-2 col-xs-2">
            <p v-if="transport.mark">
              {{ transport.mark ? transport.mark : '' }}
              <br v-if="transport.model">
              {{ transport.model ? transport.model : '' }}
            </p>
            <p v-else>-</p>
          </div>
          <div class="col-md-2 col-xs-3">
            <p>{{ transport.color ? transport.color : '-' }}</p>
          </div>
          <div class="col-md-3 col-xs-3">
            <p>{{ transport.owner ? transport.owner : '-' }}</p>
          </div>
          <transport-action-list-menu
            :visitor="applicationVisitor"
            :visitor-key="visitorKey"
            :application-id="applicationId"
            :application-key="applicationKey"
            :transport="transport"
            :transport-index="key"
            :base-url="baseUrl"
            ref="listmenu"
          />
        </div>
      </div>
    </template>
  </application-item>
</template>

<script>
import ApplicationItem from '../application/ApplicationItem.vue'
import actionListMenuItemCommandMixin from '../../mixins/actionListMenuItemCommandMixin'
import VisitorActionListMenu from './VisitorActionListMenu.vue'
import TransportActionListMenu from './TransportActionListMenu.vue'
import DropdownImage from './menu-components/DropdownImage.vue'

export default {
  name: 'VisitorApplicationItem',

  components: {
    DropdownImage,
    VisitorActionListMenu,
    TransportActionListMenu,
    ApplicationItem
  },

  mixins: [actionListMenuItemCommandMixin],

  props: {
    application: {
      type: Object
    },
    applicationKey: Number,
    pagination: {},
    statuses: {
      type: [Object, Array],
      default() {
        return {
          draft: { name: 'Черновик' },
          awaiting: { name: 'Ожидает подписания' },
          discard: { name: 'Отозвана' }
        }
      }
    },
    visitorKey: Number
  },

  data() {
    return {
      baseUrl: process.env.VUE_APP_API_BASE_URL
    }
  },

  computed: {
    applicationId() {
      return Number(this.application.id)
    },

    applicationPdf() {
      return this.application.pdf
    },

    applicationVisitor() {
      return this.application.applicationVisitor
    }
  },

  methods: {
    spliceApplication(deleteFrom, blockId, applicationId, index) {
      this.$emit('splice-application', deleteFrom, blockId, applicationId, index)
    },

    updateStatuses(status) {
      this.$emit('update-statuses', status)
    },

    url(action, afterAction = '') {
      return String(this.baseUrl + '/site/index?' + action + '=' + this.application.id + afterAction)
    }
  }
}
</script>
